/**
 * @namespace transform/object
 * @see module:@kids/lib/transform/object
 */

/**
 * @module @kids/lib/transform/object
 * @see transform/object
 * @desc Stellt alle puren Funktionen zur Object-Umwandlung zur Verfügung.
 * @example
 * import {normalizeStyle} from '@kids/lib/transform/object';
 *
 * normalizeStyle({width: 200}); // -> {width: '200px'}
 */

/** Fasst die Props eines Objekts zu einem String zusammen.
 * @alias transform/object.join
 * @param {Object} object
 * @param {string} [seperator=","]
 * @param {string} [allocator=":"]
 * @return {string}
 */
export function join(object, seperator = ',', allocator = ':')
{
    let joinedString = '';

    for (const key in object)
    {
        joinedString += key + allocator + object[key].toString() + seperator;
    }

    return joinedString.substring(0, joinedString.length - seperator.length);
}

/** Bereitet die Werte eines Objektes so vor, dass sie valide für den Inline-Style eines HTML-Elements sind.
 * @alias transform/object.normalizeStyle
 * @param {Object} style
 * @param {string} [unit="px"]
 * @return {Object} Ein neues Objekt.
 */
export function normalizeStyle(style, unit = 'px')
{
    const newStyle = {};

    for (const prop in style)
    {
        const declaration = style[prop];
        const type = typeof declaration;
        if (type === 'number')
        {
            newStyle[prop] = prop !== 'zIndex' ? `${declaration}${unit}` : `${declaration}`;
        }
        else if (type === 'string')
        {
            newStyle[prop] = declaration;
        }
        else
        {
            newStyle[prop] = '';
        }
    }

    return newStyle;
}
